let properties = {
  getErrorMessage(message) {

    if (message.includes("student.not.associated.with.dp"))
        return "Ο φοιτητής δεν έχει βιβλία που να μπορεί να παραλάβει ή να επιστρέψει από το συγκεκριμένο Σημείο Διανομής";

        //-----------
    else if (message.includes("student.not.found"))
          return "Δεν βρέθηκε Φοιτητής για αυτό το PIN";

        //-----------
    else if (message.includes("statements.exist"))
        return "Έχουν ήδη ξεκινήσει δηλώσεις για το έτος αυτό, δεν επιτρέπεται πλέον η μαζική μεταφορά τμημάτων. Μπορείτε να κάνετε μεμωνομένες αλλαγές.";

        //-----------
  else if (message.includes("book.not.published"))
        return "book.not.published";

        //----------
  else if (message.includes("statement.not.in.current.period"))
        return "Το βιβλίο δεν ανήκει σε δήλωση του τρέχοντος εξαμήνου. Δεν επιτρέπεται να παραδοθεί ή να επιστραφεί.";

    //----------
  else if (message.includes("{expired.date}"))
    return "Η επιτρεπόμενη περίοδος επιστροφών έχει λήξει. Δεν επιτρέπονται επιστροφές βιβλίων.";

      //----------
  else if (message.includes("expired.date"))
        return "Η επιτρεπόμενη περίοδος παράδοσεων έχει λήξει. Δεν επιτρέπονται παραδόσεις βιβλίων.";

      //----------
  else if (message.includes("in.library"))
        return "Το βιβλίο έχει επιστραφεί σε βιβλιοθήκη";

      //----------
  else if (message.includes("book.expired"))
        return "Το βιβλίο είναι ληξιπρόθεσμο";

      //----------
  else if (message.includes("book.exchanged"))
        return "Έχετε παραδόσει το βιβλίο σε άλλον φοιτητή μέσω της διαδικασίας ανταλλαγής. Δεν μπορείτε να το επιστρέψετε.";

      //----------
  else if (message.includes("wrong.distribution.point"))
        return "Το σύγγραμμα δεν έχει παραδοθεί απο αυτό το σημείο διανομής.";

      //----------
  else if (message.includes("inactive.student"))
        return "inactive.student";

      //----------
  else if (message.includes("not.enough.credits"))
        return "Το βιβλίο έχει δηλωθεί ως επιλογή εξαργύρωσης μονάδων από ανταλλαγές αλλά ο φοιτητής δεν έχει αρκετές μονάδες για την παραλαβή.";

      //----------
  else if (message.includes("nPlus2.normal.type"))
        return "Ο φοιτητής είναι Ν+2 και μπορεί να παραλάβει βιβλία μόνο από εξαργύρωση μονάδων από ανταλλαγές.";

      //----------
  else if (message.includes("exchange.src.exists"))
        return "Έχει ενεργοποιηθεί η διαδικασία παραλαβής από φοιτητή. Δεν μπορείτε να παραλάβετε το βιβλίο από το Σ.Δ.";

      //----------
  else if (message.includes("has no availability for"))
        return "Δεν είναι δυνατή η παράδοση του βιβλίου καθώς δεν υπάρχει διαθεσιμότητα για το βιβλίο που επιλέξατε.";

      //----------
  else if (message.includes("student.has.wrongly.delivered.books"))
        return "Έχετε εκρεμμότητες βιβλίων που έχετε παραλάβει εσφαλμένα στην προηγούμενη δήλωσή σας. Δεν μπορείτε να κάνετε υποβολή δήλωσης ή να παραλάβετε βιβλία μέχρι να διευθετήσετε τις εκκρεμότητες αυτές.";

      //----------
  else if (message.includes("{no.books.in.courses}"))
    return "Το τμήμα δεν έχει επιλέξει βιβλία στο πρόγραμμα σπουδών του.";

      //-----------
  else
    return "Παρουσιάστηκε κάποιο σφάλμα στην επικοινωνία με το σύστημα. Πατήστε \"Ανανέωση\" στον browser και αν το πρόβλημα επιμείνει παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών";
  }
};

export default properties





// WEBPACK FOOTER //
// ./src/js/PropertiesMap.js